import {
	configureClientLogger,
	installGlobalErrorHandlers,
} from "@bodhistreams/utils";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Client telemetry → backend ClickHouse (db_logs_frontend). Captures API/auth
// errors (via axios), failed mutations (via queryClient), and uncaught JS errors.
configureClientLogger({ app: "landing", release: import.meta.env?.MODE || "" });
installGlobalErrorHandlers();

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
